import { useNavigate } from "react-router-dom";
import { FaTimes, FaLock } from "react-icons/fa";
import { useLoginRequiredModal } from "./LoginRequiredContext";
import "./LoginRequiredModal.css";
import { useTranslation } from "react-i18next";


const LoginRequiredModal = () => {

    const navigate = useNavigate();

    const { t } = useTranslation();

    const {
        isOpen,
        closeLoginModal
    } = useLoginRequiredModal();

    if (!isOpen) return null;

    return (
        <div className="login-required-overlay">

            <div className="login-required-modal">

                <button
                    className="login-required-close"
                    onClick={closeLoginModal}
                >
                    <FaTimes />
                </button>

                <div className="login-required-icon">
                    <FaLock />
                </div>

                <h3>
                    {t("loginRequired.title")}
                </h3>

                <p>
                    {t("loginRequired.description")}
                </p>

                <button
                    className="login-required-btn"
                    onClick={() => {
                        closeLoginModal();
                        navigate("/login");
                    }}
                >
                    {t("loginRequired.button")}
                </button>

            </div>

        </div>
    );
};

export default LoginRequiredModal;